export default __webpack_public_path__ + "static/media/confirmAccount-01.ba253ddf.svg";